import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Typography, Button, Stack } from "@mui/material";

export default function BillingReturn() {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate("/");
        }, 5000); // redirect after 4s
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <Box sx={{
            position: "fixed",      // detach from parent flow
            top: 0,
            left: 0,
            width: "100vw",         // full viewport width
            height: "100vh",        // full viewport height
            display: "flex",        // center with flexbox
            alignItems: "center",
            justifyContent: "center",
            p: 2,
        }}>
            <Stack spacing={2}>
                <Typography variant="h4">Billing Updated</Typography>
                <Typography variant="body1" color="text.secondary">
                    You’ve returned from billing. Any changes you made will appear shortly.
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    You’ll be redirected to the home page in a moment.
                </Typography>
                <Button variant="contained" onClick={() => navigate("/")}>
                    Return Now
                </Button>
            </Stack>
        </Box>
    );
}